import { AppBar, Hidden, IconButton, Toolbar } from '@mui/material';
import Box from '@mui/material/Box';
import MenuIcon from '@mui/icons-material/Menu'


function Navbar({ handleDrawerToggle }) {

  return (
    <Box className="" >

      <AppBar className='bg-white' position="fixed" sx={{ boxShadow: "0", zIndex: 100 }}  >
        <Toolbar className='' style={{ display: 'flex', justifyContent: 'space-between' }} >
          <Box className=' d-flex  align-items-center justify-content-between w-100 p-2 rounded-2 nav-style'>
            <Box className="  d-flex justify-content-start align-items-center" >
              <h5 className=' my-2 mx-3 fw-bold' style={{ color: "#003B93" }}>  Organisation Group Chart System</h5>
            </Box>
            <div className='d-flex align-items-center'>
              <Hidden
                mdUp
              >
                <IconButton onClick={handleDrawerToggle}>
                  <MenuIcon style={{ color: "black" }} />
                </IconButton>
              </Hidden>
            </div>

          </Box>
        </Toolbar>
      </AppBar>

    </Box>
  );
}

export default Navbar;
